import React from "react";
import FilterField from "./FilterField";

// Filtres principaux, posés dans la barre de recherche à côté du champ libre
// (définitions `principal: true`) : toujours visibles, même panneau replié.
// Rendu compact, libellé dans le cadre du champ.
const InlineFilters = ({ definitions = [], filters = {}, onChange, onSet, label = "Filtres principaux" }) =>
  definitions.length > 0 ? (
    <div className="search-toolbar__filtres" role="group" aria-label={label}>
      {definitions.map((definition) => (
        <FilterField
          key={definition.name}
          definition={definition}
          value={filters[definition.name]}
          values={filters}
          onChange={onChange}
          onSet={onSet}
          variant="barre"
        />
      ))}
    </div>
  ) : null;

export default InlineFilters;
